import React from 'react';
import './about.css';

const About = () => {
  return (
    <div className='about-container'>
      <h2 id='about'>About Me</h2>
      <p id='about-message'>
        I'm a customer-facing implementation engineer with a thing for debugging tricky integrations, building automation that actually saves people time, and figuring out why things break in production.
        <br/>
        I've spent the last few years at the intersection of technical customers and engineering teams — onboarding enterprise clients, investigating cross-system failures, and translating recurring problems into fixes that scale. And I work best in fast-moving SaaS environments where the problems are real and shipping matters.
        <br/>
        Outside of work, I'm happiest when I'm traveling: new places, new people, new problems to figure out. Conveniently, I don't mind at all when work takes me somewhere new 🌍
        </p>
    </div>
  );
};

export default About;